import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Grid,
} from "@mui/material";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter, getStorageItem } from "../../Common/Utility";

const quickAccessItems = [
  {
    title: "Aufträge",
    description: "Aufträge verwalten und erfassen",
    icon: <ReceiptOutlinedIcon />,
    to: "/TrackerStudents",
  },
  {
    title: "Abrechnungsübersicht",
    description: "Übersicht aller Abrechnungen",
    icon: <PlagiarismOutlinedIcon />,
    to: "/CalculationsView",
  },
  {
    title: "Schüler/in",
    description: "Schülerstammdaten verwalten",
    icon: <Diversity3OutlinedIcon />,
    to: "/Students",
  },
];

export default function WelcomePage() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    (async () => {
      const name = await getStorageItem("login", "userName");
      if (name) setUserName(capitalizeFirstLetter(name));
    })();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "70vh",
        py: 4,
        px: { xs: 2, sm: 3 },
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box sx={{ maxWidth: 900, mx: "auto" }}>
        {/* Welcome section */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            component="h1"
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#2196F3",
              letterSpacing: "-0.02em",
            }}
          >
            Willkommen
          </Typography>
          {userName && (
            <Typography
              variant="h6"
              sx={{
                mt: 1,
                fontWeight: 500,
                color: "#424242",
              }}
            >
              {userName}
            </Typography>
          )}
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              maxWidth: 520,
              mx: "auto",
              lineHeight: 1.7,
              color: "#616161",
            }}
          >
            AbrechnungsSystem unterstützt Sie bei der Verwaltung von Aufträgen
          </Typography>
        </Box>

        {/* Quick access header */}
        <Typography
          variant="subtitle2"
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            mb: 2,
            fontWeight: 600,
            color: "#424242",
          }}
        >
          Schnellzugriff
        </Typography>

        {/* Quick access cards */}
        <Grid container spacing={2}>
          {quickAccessItems.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.to}>
              <Card
                component={Link}
                to={item.to}
                sx={{
                  height: "100%",
                  textDecoration: "none",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  transition: "box-shadow 0.2s ease, transform 0.2s ease",
                  "&:hover": {
                    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <CardActionArea
                  sx={{
                    height: "100%",
                    py: 2,
                    px: 2,
                    "&.Mui-focusVisible": { boxShadow: 2 },
                  }}
                >
                  <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 1.5,
                        bgcolor: "#2196F3",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 1.5,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ color: "#424242" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 0.5,
                        lineHeight: 1.5,
                        color: "#757575",
                      }}
                    >
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
